/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-09-13 15:33:18
 * @modify date 2021-09-13 15:33:18
 * @desc [微信认证]
 */
/// <reference path="wx.d.ts" />
import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { computed } from 'mobx';
import { Subject } from 'rxjs';
import { EnumAPI } from '../../apis';
import { EnumCustomPlatform } from '../../enums';
import { AjaxBasics, BaseModel, EnumPlatform, Log } from '../../libraries';
import { onCreateFactoryAuth } from '../system/auth';
import { onCreateFactoryUser } from '../system/userModel';
@BindAll()
export class WechatController {
  constructor(public appId) {}
  /**
   * WeixinJSBridge 异步数据加载订阅
   * @type {Promise<any>}
   * @memberof ControllerUser
   */
  readonly WeixinJSSubject = new Subject();
  readonly User = onCreateFactoryUser();
  readonly Model = new BaseModel({ type: 'object', storageKey: 'wechat' });
  /**
   * 认证模块 默认从 cookie 中获取 token 不需要手动设置 token
   * 除非是地址栏解析或者其他方式等等
   * @memberof SystemController
   */
  readonly Auth = onCreateFactoryAuth();

  @computed
  public get wxAppId() {
    return lodash.get(this.User.value, 'wxAppId');
  }
  @computed
  public get bindToken() {
    return lodash.get(this.Model.value, 'bindToken');
  }
  @computed
  public get wechatName() {
    return lodash.get(this.Model.value, 'baseInfo.extendInfo.nickname');
  }
  /** 小程序环境 */
  @computed
  public get miniprogram() {
    return lodash.eq(
      lodash.get(this.Model.value, 'platform'),
      EnumPlatform.weapp,
    );
  }
  /** platform */
  @computed
  public get platform() {
    return lodash.get(this.Model.value, 'platform', EnumPlatform.mobile);
  }

  /** 微信openID */
  @computed
  public get openid() {
    return lodash.get(this.Model.value, 'openid');
  }
  @computed
  public get weappOpenid() {
    return lodash.get(this.Model.value, 'openId');
  }
  @computed
  public get weappUnionId() {
    return lodash.get(this.Model.value, 'unionId');
  }
  /** 关注公众号 */
  @computed
  public get subscribe() {
    return lodash.eq(lodash.get(this.Model.value, 'subscribe'), 1);
  }
  /** 小程序环境 */
  // @computed
  // public get miniprogram() {
  //     return lodash.get(this.Model.value, 'miniprogram', false);
  // }
  /** 当前属于大联想小程序子页面 */
  @computed
  public get miniprogramChildren() {
    return lodash.eq(
      lodash.get(this.Model.value, 'platform'),
      EnumPlatform.weapp,
    );
  }
  get WeixinJSBridge() {
    if (wx) {
      return wx;
    }
    return undefined;
  }
  /** 初始化 */
  isReady = false;
  /** 加载 */
  loading = false;
  jsApiList: Array<any> = [
    'updateAppMessageShareData',
    'updateTimelineShareData',
    // 'onMenuShareWeibo',
    // 'onMenuShareQZone',
    // 'startRecord',
    // 'stopRecord',
    // 'onVoiceRecordEnd',
    // 'playVoice',
    // 'pauseVoice',
    // 'stopVoice',
    // 'onVoicePlayEnd',
    // 'uploadVoice',
    // 'downloadVoice',
    'chooseImage',
    // 'previewImage',
    'uploadImage',
    // 'downloadImage',
    // 'translateVoice',
    // 'getNetworkType',
    // 'openLocation',
    // 'getLocation',
    // 'hideOptionMenu',
    // 'showOptionMenu',
    // 'hideMenuItems',
    'showMenuItems',
    // 'hideAllNonBaseMenuItem',
    // 'showAllNonBaseMenuItem',
    // 'closeWindow',
    // 'scanQRCode',
    'chooseWXPay',
    // 'openProductSpecificView',
    // 'addCard',
    // 'chooseCard',
    // 'openCard'
  ];
  openTagList: Array<any> = ['wx-open-launch-weapp', 'wx-open-subscribe'];
  onComplete() {
    this.WeixinJSSubject.next(true);
    this.WeixinJSSubject.complete();
  }
  async onReady(signUrl: string) {
    if (this.loading) {
      return Log.warning(` Weixin 加载中`);
    }
    if (this.isReady) {
      return Log.warning(` Weixin 已经加载`);
    }
    this.loading = true;
    const config = await AjaxBasics.request<{
      debug?: boolean; // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: string; // 必填，公众号的唯一标识
      timestamp: number; // 必填，生成签名的时间戳
      nonceStr: string; // 必填，生成签名的随机串
      signature: string; // 必填，签名，见附录1
      jsApiList: Array<any>; // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      openTagList?: Array<any>;
    }>({
      ...EnumAPI.wechat_jsapi_sign,
      body: { signUrl },
      headers: { 'x-app-id': this.appId },
    });
    try {
      this.WeixinJSBridge.miniProgram.getEnv((res) => {
        console.log('LENG ~ WechatController ~ miniProgram ~ getEnv', res);
        this.Model.merge(res);
      });
      const res = await new Promise((res, rej) => {
        Log.info(` Weixin onReady`, config);
        this.WeixinJSBridge.ready(() => {
          console.log(
            'LENG ~ WechatController ~ this.WeixinJSBridge.ready ~ ready',
          );
          res(config);
        });
        this.WeixinJSBridge.error((error) => {
          console.log(
            'LENG ~ WechatController ~ this.WeixinJSBridge.error ~ error',
            error,
          );
          rej(error);
        });
        this.WeixinJSBridge.config({
          jsApiList: this.jsApiList,
          openTagList: this.openTagList,
          appId: config.appId,
          nonceStr: config.nonceStr,
          signature: config.signature,
          timestamp: config.timestamp,
        });
      });
      this.isReady = true;
      this.loading = false;
      console.log('LENG ~ WechatController ~ miniProgram ~ getEnv');
      this.WeixinJSSubject.next(true);
      this.WeixinJSSubject.complete();
      return res;
    } catch (error) {
      this.loading = false;
      this.WeixinJSSubject.error(error);
      this.WeixinJSSubject.complete();
      throw error;
    }
  }
  /**
   * 获取“分享给朋友”及“分享到QQ”按钮点击状态及自定义分享内容接口（新）
   */
  updateAppMessageShareData(params: wx.IupdateAppMessageShareData) {
    Log.info('【 updateAppMessageShareData 】', params);
    this.WeixinJSSubject.toPromise().then(() =>
      this.WeixinJSBridge.updateAppMessageShareData(params),
    );
    return params;
  }
  /**
   * 获取微信小程序 appid
   * @param jsCode
   */
  async onWeappSession(jsCode, appId) {
    const res = await AjaxBasics.request({
      ...EnumAPI.wechat_weapp_session,
      body: { jsCode },
      headers: { 'x-app-id': appId },
    });
    this.Model.merge(res);
    return res;
  }

  async onSend() {
    return AjaxBasics.request({
      ...EnumAPI.wechat_send,
      body: {
        'templateId': 'eYV50ZNOMZIajfYW7lSsdPOrL9XXMxOpkJ_FGOJ-u2Y',
        'openId': this.openid,
        'params': {
          'thing11': '商机状态通知',
          'phrase2': '测试状态',
        },
      },
      headers: { 'x-app-id': this.appId },
    });
  }
  /**
   * 授权 url https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/Wechat_webpage_authorization.html#0
   * @param redirect_uri
   */
  getAuthorizeUrl(
    redirect_uri,
    scope: 'snsapi_base' | 'snsapi_userinfo' = 'snsapi_userinfo',
    state?,
    appId: any = this.wxAppId,
  ) {
    const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${encodeURIComponent(
      redirect_uri,
    )}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`;
    Log.success('AuthorizeUrl', url);
    return url;
  }

  getWechatCode() {
    // https://developers.weixin.qq.com/doc/oplatform/Website_App/WeChat_Login/Wechat_Login.html
    // onWxLogin(id, appId, state = "login", redirect_uri = window.location.origin,addCss?:string) {
    // new WxLogin({
    //     self_redirect: false,
    //     id: id,
    //     appid: appId,
    //     scope: "snsapi_login",
    //     redirect_uri: encodeURIComponent(redirect_uri),
    //     state: state,
    //     style: "",
    //     response_type: "code",
    //     href: !addCss?
    //     "data:text/css;base64,LyogLmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDIwMXB4O30NCi5pbXBvd2VyQm94IC50aXRsZSB7ZGlzcGxheTogbm9uZTt9DQouaW1wb3dlckJveCAuaW5mbyB7d2lkdGg6IDIwMHB4O30NCi5zdGF0dXNfaWNvbiB7ZGlzcGxheTogbm9uZX0NCi5pbXBvd2VyQm94IC5zdGF0dXMge3RleHQtYWxpZ246IGNlbnRlcjt9ICovDQouaW1wb3dlckJveCAudGl0bGV7DQogICAgZGlzcGxheTogbm9uZTsNCn0NCi5pbXBvd2VyQm94IC5pbmZvIHtkaXNwbGF5OiBub25lfQ0KLmltcG93ZXJCb3ggLnFyY29kZSB7DQogICAgd2lkdGg6IDE0OHB4Ow0KICAgIGJveC1zaXppbmc6IGJvcmRlci1ib3g7DQogICAgbWFyZ2luLXRvcDogMDsNCn0NCi5pbXBvd2VyQm94IC53cnBfY29kZXsNCiAgICB3aWR0aDoxNDhweDsNCn0="
    //     : addCss
    // })
    // }
  }

  /**
   * 登陆微信获取信息
   */
  async onAuth(body) {
    const res = await AjaxBasics.request({
      ...EnumAPI.wechat_login,
      body: lodash.assign(body, { wxAppType: 1 }), // 1公众号
      headers: {
        'x-wechat-app-id': lodash.get(body, 'wxAppId'),
        'x-client-info': `platform=${
          lodash.get(body, 'isPc')
            ? EnumCustomPlatform.pc
            : EnumCustomPlatform.mobile
        }`,
      },
    });
    if (!lodash.get(body, 'isPc')) {
      let userTokenResponse = lodash.get(res, 'userTokenResponse');
      if (userTokenResponse) {
        const { idToken } = userTokenResponse;
        this.Auth.onSaveAccessToken(idToken);
        this.User.merge({ token: idToken, ...userTokenResponse });
      } else {
        this.Model.merge({ bindToken: lodash.get(res, 'bindToken') });
      }
    }
    return res;
  }

  /**
   * 新用户绑定手机号
   */
  async bindAuth(body) {
    if (!lodash.get(body, 'bindToken')) {
      body = lodash.assign(body, { bindToken: this.bindToken });
    }

    let headers = lodash.get(body, 'isWeapp')
      ? {
          'x-client-info': `platform=${EnumCustomPlatform.weapp}`,
        }
      : {};

    const intentionBu = lodash.get(body, 'intentionBu');
    headers = intentionBu
      ? lodash.assign(headers, {
          'x-business-unit': intentionBu,
        })
      : headers;

    const res: any = await AjaxBasics.request({
      ...EnumAPI.wechat_bind_user,
      body,
      headers,
    });
    this.Auth.onSaveAccessToken(lodash.get(res, 'idToken'));
    this.User.merge({ token: lodash.get(res, 'idToken'), ...res });
    return res;
  }

  /**
   * 轮询检查微信登陆
   */
  async onCheckWechatLogin(requestId) {
    const res = await AjaxBasics.request({
      ...EnumAPI.wechat_check_login,
      body: { requestId },
    });
    let userTokenResponse = lodash.get(res, 'userTokenResponse');
    if (userTokenResponse) {
      const { idToken } = userTokenResponse;
      this.Auth.onSaveAccessToken(idToken);
      this.User.merge({ token: idToken, ...userTokenResponse });
    } else {
      this.Model.merge({ bindToken: lodash.get(res, 'bindToken') });
    }
    return res;
  }

  /**
   * 轮询检查微信绑定
   */
  async onCheckWechatBind(requestId) {
    return await AjaxBasics.request({
      ...EnumAPI.wechat_check_bind,
      body: { requestId },
    });
  }

  /**
   * 获取微信扫码标识
   */
  getWechatRequestId(scene) {
    return AjaxBasics.request({
      ...EnumAPI.wechat_get_requestId,
      body: { scene },
    });
  }

  /**
   * 绑定微信号
   */
  onBindWechat(body) {
    let idToken = lodash.get(body, 'idToken') || this.Auth.AccessToken;
    return AjaxBasics.request({
      ...EnumAPI.wechat_bind,
      body,
      headers: {
        'bp-token': idToken,
        'x-wechat-app-id': lodash.get(body, 'wxAppId'),
        'x-client-info': `platform=${
          lodash.get(body, 'isPc')
            ? EnumCustomPlatform.pc
            : EnumCustomPlatform.mobile
        }`,
      },
    });
  }

  /**
   * 解除绑定微信号
   */
  onRelieveBindWechat() {
    return AjaxBasics.request({
      ...EnumAPI.wechat_relieve_bind,
    });
  }

  // /** 绑定微信号 */
  // bindWechat(body) {
  //     return AjaxBasics.request({
  //         ...EnumAPI.wechat_bind,
  //         body,
  //     })
  // }

  // /** 解除绑定微信号 */
  // relieveBindWechat(body) {
  //     return AjaxBasics.request({
  //         ...EnumAPI.wechat_relieve_bind,
  //         body,
  //     })
  // }

  /** 根据idToken获取微信id */
  async getWechatIdBytoken() {
    this.Model.merge({ baseInfo: {} });
    const res = await AjaxBasics.request({
      ...EnumAPI.wechat_get_id,
    });
    // this.User.merge(lodash.pick(res, 'userId'))
    if (res) {
      this.Model.merge({ baseInfo: res });
    }
    return res;
  }

  /** 保存微信扩展信息 */
  wechatExtendSave(body) {
    return AjaxBasics.request({
      ...EnumAPI.wechat_extend_save,
      body: {
        'extendInfoList': body,
      },
    });
  }
}
